import { getPorcentajeIVA } from './utils'; // Ajusta según sea necesario

export const handleInputChange = (e, setForm, Inputs, setErrors, form, setImageUrlLocal) => {
  const { name, value, files } = e.target;

  // Si es cualquier otro campo
  if (files && files.length > 0) {
    const selectedFile = files[0];
    setForm((prevForm) => ({
      ...prevForm,
      [name]: selectedFile,
    }));
    if (name === 'art_imagen') {
      const imageUrl = URL.createObjectURL(selectedFile);
      setImageUrlLocal(imageUrl);
    }
  } else {
    let error = '';
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  }

  if (name === "art_ncostosinimpuesto") {
    const costoSinImpuesto = parseFloat(value) || 0;

    setForm((prevState) => {
      const porcentajeIVA = getPorcentajeIVA(prevState.art_iva_cotizacion);
      const flete = parseFloat(prevState.art_flete) || 0;

      let nuevoCostoConImpuesto = costoSinImpuesto * (1 + porcentajeIVA);
      let nuevoPrecioCosto = nuevoCostoConImpuesto * (1 + flete / 100);

      return {
        ...prevState,
        art_ncostosinimpuesto: costoSinImpuesto,
        art_ncostoconimpuesto: nuevoCostoConImpuesto.toFixed(2),
        art_npreciocosto: nuevoPrecioCosto.toFixed(2),
        art_npreciomayorista: nuevoPrecioCosto.toFixed(2)* (1 + prevState.porc_may/ 100),
        art_nprecioventa: nuevoPrecioCosto.toFixed(2)*(1 + prevState.porc_min/ 100),
      };
    });
    return;
  }

  if (name === "art_flete") {
    const flete = parseFloat(value) || 0;

    setForm((prevState) => {
      const porcentajeIVA = getPorcentajeIVA(prevState.art_iva_cotizacion);
      const costoConImpuesto = prevState.art_ncostosinimpuesto * (1 + porcentajeIVA);

      let nuevoPrecioCosto = costoConImpuesto * (1 + flete / 100);

      return {
        ...prevState,
        art_flete: flete,
        art_npreciocosto: nuevoPrecioCosto.toFixed(2),
        art_npreciomayorista: nuevoPrecioCosto.toFixed(2)* (1 + prevState.porc_may/ 100),
        art_nprecioventa: nuevoPrecioCosto.toFixed(2)*(1 + prevState.porc_min/ 100),
      };
    });
    return;
  }

  if (name === "art_iva_cotizacion") {
    const porcentajeIVA = getPorcentajeIVA(value);

    setForm((prevState) => {
      const costoSinImpuesto = parseFloat(prevState.art_ncostosinimpuesto) || 0;
      const flete = parseFloat(prevState.art_flete) || 0;

      let nuevoCostoConImpuesto = costoSinImpuesto * (1 + porcentajeIVA);
      let nuevoPrecioCosto = nuevoCostoConImpuesto * (1 + flete / 100);

      return {
        ...prevState,
        art_iva_cotizacion: value,
        art_ncostoconimpuesto: nuevoCostoConImpuesto.toFixed(2),
        art_npreciocosto: nuevoPrecioCosto.toFixed(2),
        art_npreciomayorista: nuevoPrecioCosto.toFixed(2)* (1 + prevState.porc_may/ 100),
        art_nprecioventa: nuevoPrecioCosto.toFixed(2)*(1 + prevState.porc_min/ 100),
      };
    });
    return;
  }
  if (name === "art_npreciocosto") {

    setForm((prevState) => {
      const costoFinal = parseFloat(prevState.art_npreciocosto) || 0;

      return {
        ...prevState,
        art_npreciocosto: costoFinal,
        art_npreciomayorista: costoFinal.toFixed(2) ,
        art_nprecioventa: costoFinal.toFixed(2),
      };
    });
    return;
  }

  if (name === "porc_may" && value !== "") {
    const porcmay = parseFloat(value) || 0;

    setForm((prevState) => {
      const costofinal = prevState.art_npreciocosto;

      let nuevoPrecioMayorista = costofinal * (1 + porcmay / 100);

      return {
        ...prevState,
        porc_may: porcmay,
        art_npreciomayorista: nuevoPrecioMayorista.toFixed(2),
      };
    });
    return;
  }

  if (name === "art_npreciomayorista" && value !== "") {
    const preciomay = parseFloat(value) || 0;

    setForm((prevState) => {
      const costofinal = prevState.art_npreciocosto;

      let nuevoPorcMayorista = ((preciomay - costofinal) / costofinal) * 100;

      return {
        ...prevState,
        art_npreciomayorista: preciomay,
        porc_may: nuevoPorcMayorista.toFixed(2),
      };
    });
    return;
  }
  
  if (name === "porc_min" && value !== "") {
    const porcmin = parseFloat(value) || 0;

    setForm((prevState) => {
      const costofinal = prevState.art_npreciocosto;

      let nuevoPrecioMinorista = costofinal * (1 + porcmin / 100);

      return {
        ...prevState,
        porc_min: porcmin,
        art_nprecioventa: nuevoPrecioMinorista.toFixed(2),
      };
    });
    return;
  }

  if (name === "art_nprecioventa" && value !== "") {
    const preciomin = parseFloat(value) || 0;

    setForm((prevState) => {
      const costofinal = prevState.art_npreciocosto;

      let nuevoPorcMinorista = ((preciomin - costofinal) / costofinal) * 100;

      return {
        ...prevState,
        art_nprecioventa: preciomin,
        porc_min: nuevoPorcMinorista.toFixed(2),
      };
    });
    return;
  }
};
